import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const Method = () => {
  const { t } = useLanguage();
  return (
  <section id="metodo" className="py-24 lg:py-32 relative" data-testid="method-section">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(255,0,85,0.06),transparent_60%)] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="max-w-3xl mb-20"
      >
        <p className="text-xs font-bold tracking-[0.3em] uppercase text-neon-cyan mb-4">{t.method.overline}</p>
        <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">
          {t.method.titleA} <span className="neon-text">{t.method.titleNeon}</span>
        </h2>
      </motion.div>

      <div className="relative">
        <div className="absolute left-5 lg:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-neon-cyan via-neon-violet to-neon-magenta opacity-40" />
        <div className="flex flex-col gap-16">
          {t.method.steps.map((s, i) => {
            const left = i % 2 === 0;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55 }}
                className={`relative flex ${left ? "lg:justify-start" : "lg:justify-end"}`}
                data-testid={`method-step-${i + 1}`}
              >
                <div className="absolute left-5 lg:left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-neon-cyan shadow-[0_0_15px_rgba(0,240,255,0.8)]" />
                <div className={`glass-panel spotlight overflow-hidden rounded-2xl p-8 ml-14 lg:ml-0 lg:w-[46%] ${left ? "" : "lg:mr-0"} hover:-translate-y-1 transition-transform duration-500`}>
                  <span className="font-display text-5xl font-black text-outline">{s.n}</span>
                  <h3 className="font-display text-2xl font-bold mt-3 mb-3">{s.title}</h3>
                  <p className="text-sm text-white/70 leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
  );
};

export default Method;
